// Module
var code = `<div style="height:145px"> <textarea show-errors id="block-input-{{block.id}}" class="form-control" ng-model="answer.value" ng-model-options="{ debounce: 1000 }" ng-required="block.required" ng-disabled="editBlock" style="height:120px"></textarea> </div> `;
// Exports
var _module_exports =code;;
var path = '/scripts/directives/blocks/textareaQuestion.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;